import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { startedHealthNavigator } from 'analytics/navigator';
import GlobalLoader from 'components/GlobalLoader';
import { useQueryParams } from 'hooks/useQueryParams';
import useSelector from 'store/useSelector';

import { useStartQuery } from './graphql/queries/Start/query';
import SelectUser from './SelectUser';
import { getNextLocation } from './utils';

const Start: React.FC = () => {
  const location = useLocation();
  const params = useQueryParams();
  const navigate = useNavigate();

  const activeUserUuid = useSelector((app) => app.activeUserUuid);
  const { data, loading } = useStartQuery({
    variables: { uuid: activeUserUuid },
  });

  useEffect(() => {
    startedHealthNavigator(activeUserUuid);
  }, []);

  if (loading) {
    return <GlobalLoader />;
  }
  const navigateToNextLocation = () => {
    navigate(getNextLocation(location));
  };

  const hasEmail = !!data?.customer?.identityProfile.email;

  if (params.get('skip_select_user') === 'true' || !hasEmail) {
    return <Navigate to={getNextLocation(location)} replace />;
  }

  return (
    <SelectUser
      activeUserUuid={activeUserUuid}
      firstName={data?.customer?.identityProfile.firstName ?? null}
      onMyselfSubmission={navigateToNextLocation}
    />
  );
};

export default Start;
